<template>
  <section>
    <!--工具条-->
    <Toolbar :buttonList="buttonList" @callFunction="callFunction">
      <template v-slot:before>
        <el-form-item>
          <el-select
            v-model="selType"
            placeholder="选择类型"
            clearable
            collapse-tags
          >
            <el-option
              v-for="(item, key) in $t('CashFlowType')"
              :key="key"
              :label="item"
              :value="parseInt(key)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="startDate"
            type="date"
            :placeholder="$t('StartDateTime')"
            value-format="yyyy-MM-dd"
            :editable="false"
            style="width: 150px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="endDate"
            type="date"
            :placeholder="$t('EndDateTime')"
            value-format="yyyy-MM-dd"
            :editable="false"
            style="width: 150px"
          ></el-date-picker>
        </el-form-item> </template
    ></Toolbar>

    <!--列表-->
    <el-table
      ref="listTable"
      :data="list"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      style="width: 100%"
      show-summary
    >
      <el-table-column label="Id" prop="Id" width="80"> </el-table-column>
      <el-table-column :label="$t('Shop.Name')">
        <template slot-scope="scope">{{
          field(scope.row.ShopInfo.Name)
        }}</template>
      </el-table-column>
      <el-table-column label="类型">
        <template slot-scope="scope">
          {{ $t("CashFlowType")[scope.row.Type] }}
        </template>
      </el-table-column>
      <el-table-column label="金额" prop="Amount">
        <template slot-scope="scope">
          <span :class="scope.row.Amount > 0 ? 'text_red' : 'text_green'">{{
            scope.row.Amount
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Value" prop="Value"> </el-table-column>
      <el-table-column label="备注" prop="Remark"> </el-table-column>
      <el-table-column label="时间">
        <template slot-scope="scope">
          {{ formatDateTime(scope.row.DateTime) }}
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="50"
        :total="total"
        style="float: right"
      ></el-pagination>
    </el-col>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="addForm" label-width="150px" ref="addForm" size="small">
        <el-form-item
          label="类型"
          prop="Type"
          :rules="{ required: true, message: $t('pleaseChoose') + '类型' }"
        >
          <el-select v-model="addForm.Type" placeholder="Select Type">
            <el-option
              v-for="(value, key) in $t('CashFlowType')"
              :key="key"
              :label="value"
              :value="parseInt(key)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="商户"
          prop="Shop_Id"
          :rules="{ required: true, message: $t('pleaseEnter') + '商户' }"
        >
          <el-select
            v-model="addForm.Shop_Id"
            filterable
            remote
            clearable
            placeholder="请输入关键词"
            :remote-method="shopRemoteMethod"
            :loading="selectShoploading"
            style="width: 300px"
          >
            <el-option
              v-for="item in shopList"
              :key="item.Id"
              :label="field(item.Name)"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('Amount')"
          prop="Amount"
          :rules="{
            required: true,
            message: $t('pleaseEnter') + $t('Amount'),
          }"
        >
          <el-input-number
            v-model.number="addForm.Amount"
            :precision="2"
            :step="0.1"
            :max="9999"
            style="width: 195px"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2 }"
            maxlength="200"
            v-model="addForm.Remark"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "util/date";
import { getCashFlowList, addCashFlow, getShopList } from "@/api/api";
import { getButtonList } from "@/promissionRouter";

export default {
  data() {
    return {
      filters: {
        name: "",
      },
      buttonList: [],
      list: [],
      total: 0,
      page: 1,
      startDate: "",
      endDate: "",
      selType: "",
      listLoading: false,
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      //新增界面数据
      addForm: {},
      selectShoploading: false,
      shopList: [],
    };
  },
  methods: {
    shopRemoteMethod(query) {
      if (query !== "") {
        let para = {
          key: query,
        };
        this.selectShoploading = true;
        getShopList(para).then((res) => {
          this.shopList = res.data.response.data;
          this.selectShoploading = false;
        });
      } else {
        this.shopList = [];
      }
    },
    formatDate: function (val) {
      return util.formatDate.format(new Date(val), "yyyy-MM-dd");
    },
    formatDateTime: function (val) {
      if (val == null) {
        return "";
      }
      return util.formatDate.format(new Date(val), "yyyy-MM-dd hh:mm");
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    searchList() {
      this.page = 1;
      this.getList();
    },
    //获取用户列表
    getList() {
      let para = {
        page: this.page,
        type: this.selType == "" ? 0 : this.selType,
        key: this.filters.name,
        startDate: this.startDate,
        endDate: this.endDate,
      };
      this.listLoading = true;
      getCashFlowList(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.list = res.data.response.data;
        this.listLoading = false;
      });
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        Amount: 0,
        Value: "",
        Remark: "",
      };
    },
    //新增
    addSubmit: function () {
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm(this.$t("submitPrompt"), this.$t("prompt"), {})
            .then(() => {
              this.addLoading = true;
              let para = Object.assign({}, this.addForm);
              para.IsDeleted = false;

              addCashFlow(para).then((res) => {
                if (util.isEmt.format(res)) {
                  this.addLoading = false;
                  return;
                }

                if (res.data.success) {
                  this.addLoading = false;
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["addForm"].resetFields();
                  this.addFormVisible = false;
                  this.getList();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            })
            .catch(() => {});
        }
      });
    },
  },
  mounted() {
    this.getList();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>